module.exports = __webpack_public_path__ + "img/confignotierror.438e0c29.svg";